<template>
  <!-- Right Column - Desktop -->
  <div class="flex flex-col gap-4 col-span-1">
    <div class="rounded-lg bg-container-bg p-6 flex flex-col">
      <h3 class="uppercase text-strong text-sm font-bold font-inter mb-[1.25rem]">CEO Editorial</h3>
      <div class="flex flex-col gap-4 w-full">
        <a v-for="editorial in ceoEditorials" :key="editorial.title" :href="editorial.link">
          <h4 class="text-sm font-semibold font-inter text-strongest">{{ editorial.title }}</h4>
          <p class="text-sm text-strong font-medium mt-1">
            {{ editorial.date.toLocaleDateString("en-US", { timeZone: "UTC" }) }}
          </p>
        </a>
      </div>
    </div>
    <div class="flex flex-col gap-4">
      <a
        v-for="video in rightSideVideoContent"
        :key="video.title"
        :href="video.video_url"
        class="flex flex-col gap-3"
      >
        <div class="relative rounded-lg overflow-hidden">
          <img :src="video.thumbnail" :alt="video.title" class="w-full h-auto object-cover" />
          <div class="absolute inset-0 flex items-center justify-center">
            <div class="w-12 h-12 rounded-full bg-white flex items-center justify-center">
              <svg class="w-5 h-5 ml-0.5" viewBox="0 0 24 24" fill="black">
                <polygon points="6,3 21,12 6,21" />
              </svg>
            </div>
          </div>
        </div>
        <div>
          <h4 class="text-sm font-semibold font-inter text-strongest">
            {{ video.title }}
          </h4>
          <p class="text-sm text-strong font-medium mt-1">
            {{ video.subtext }}
          </p>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
import newsfeed_value from "@/assets/images/newsfeed_value.png";
import newsfeed_alamo from "@/assets/images/newsfeed_alamo.png";

const rightSideVideoContent = [
  {
    thumbnail: newsfeed_value,
    video_url: "#",
    title: "How we drive value",
    subtext:
      "At Phoenix Energy, we're committed to sustainable growth and responsible energy solutions. Discover how our strategic investments and innovative technologies drive value for our investors and the planet.",
  },
  {
    thumbnail: newsfeed_alamo,
    video_url: "#",
    title: "Our Return to the Alamo",
    subtext:
      "Join us as we return to the iconic Alamo, where we reflect on our journey, celebrate our milestones, and share our vision for the future of energy. This is more than a visit; it's a testament to our roots and our commitment to innovation.",
  },
];

const ceoEditorials = [
  {
    title: "Building Momentum: Our Next Phase of Growth",
    date: new Date("2026-02-010"),
    link: "#",
  },
  {
    title: "What We Learned This Quarter and Where We're Headed",
    date: new Date("2025-12-02"),
    link: "#",
  },
  {
    title: "Innovating With Purpose: How We're Raising the Bar",
    date: new Date("2025-10-17"),
    link: "#",
  },
  {
    title: "Strengthening Our Foundation for a Stronger Future",
    date: new Date("2024-07-02"),
    link: "#",
  },
];
</script>
